import React from 'react';
import LocationTemplate from './LocationTemplate';

const GarnerPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Garner"
      stateName="North Carolina"
      countyName="Wake"
      zipCodes={["27529"]}
      latitude={35.7113}
      longitude={-78.6142}
      population={31407}
      historicalFact="Incorporated in 1905, developed as a railroad community southeast of Raleigh."
      nearbyTowns={[
        "Raleigh, NC",
        "Clayton, NC",
        "Fuquay-Varina, NC",
        "Apex, NC",
        "Cary, NC",
        "Holly Springs, NC",
        "Knightdale, NC",
        "Smithfield, NC"
      ]}
    />
  );
};

export default GarnerPage;